// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { memo, useState } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import NavBar from "../NavBar"
import randomWords from "random-words"
import * as styles from "./styles.module.scss"

const PhraseClicker: React.FC = () => {
  const nextPhrase = (numWords: number): string => {
    return randomWords(numWords).join(" ")
  }

  const updatePhrase = (numWords: number) => {
    setRandPhrase(nextPhrase(2))
  }

  const [randPhrase, setRandPhrase] = useState(nextPhrase(2))

  return (
    <button className={styles.phrase} onClick={() => updatePhrase(2)}>
      <span>{randPhrase}</span>
    </button>
  )
}

const Header: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      corpLogo: file(relativePath: { eq: "omg-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 138) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  const omgLogo = data.corpLogo.childImageSharp.fluid

  return (
    <header>
      <div className={styles.col1}>
        <NavBar />
      </div>
      <div className={styles.col2}>
        <div className={styles.logo}>
          <Link to="/">
            <Img fluid={omgLogo} alt="One More Game's logo" />
          </Link>
        </div>
      </div>
      <div className={styles.col3}>{/* <PhraseClicker /> */}</div>
    </header>
  )
}

export default memo(Header)
